<template>
  <v-container>
    <v-card>
      <v-container class="pb-0 pt-2">
        <v-card-actions class="pb-0 pl-0 pr-0 pt-0">
          <span class="text-h6 pl-0"
            >Formato de importación - {{ tipoEntidad }}</span
          >
          <v-spacer></v-spacer>
          <v-tooltip text="Cerrar" location="left">
            <template v-slot:activator="{ props }">
              <v-btn
                color="primary"
                v-bind="props"
                class="to-right"
                :icon="closeIcon"
                id="v-btn-close-formato-importaciones"
                @click="closeModal"
              >
              </v-btn>
            </template>
          </v-tooltip>
        </v-card-actions>
        <v-card-text class="px-0 py-0">
          <v-data-table
            :headers="headers"
            :items="formatoData"
            :hide-default-header="isMobile"
            :loading="loading"
            :items-per-page="15"
            :hide-default-footer="formatoData.length < 11"
            density="compact"
            class="elevation-1"
          >
            <template v-slot:[`item.requerido`]="{ item }">
              <v-icon
                :color="item.requerido ? 'success' : 'grey'"
                :icon="item.requerido ? 'mdi-check' : 'mdi-close'"
                size="small"
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pb-3 pr-0">
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            variant="text"
            @click="exportFormatEjemplo"
            id="v-btn-exportar-formato"
          >
            Exportar formato ejemplo
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import enums from "@/utils/enums";
import helpersExcel from "@/utils/helpers/importExportExcel.js";

export default {
  name: "VerFormatoImportaciones",
  props: {
    tipoEntidad: {
      type: String,
      required: true,
      validator: (value) =>
        ["Farmacias", "Entidad emisora", "Medico emisor"].includes(value),
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
    }),
    tipoImportacionId() {
      const mapping = {
        "Medico emisor": 1,
        "Entidad emisora": 2,
        "Farmacias": 3,
      };
      return mapping[this.tipoEntidad];
    },
    nombreArchivoExport() {
      const mapping = {
        "Medico emisor": "Formato importación médicos emisores",
        "Entidad emisora": "Formato importación entidades emisoras",
        "Farmacias": "Formato importación farmacias",
      };
      return mapping[this.tipoEntidad];
    },
    nombreHojaExport() {
      const mapping = {
        "Medico emisor": "Formato médicos emisores",
        "Entidad emisora": "Formato entidades emisoras", 
        "Farmacias": "Formato farmacias",
      };
      return mapping[this.tipoEntidad];
    },
  },
  data() {
    return {
      loading: false,
      formatoData: [],
      headers: [
        { title: "Campo", value: "nombreCampo", align: "start" },
        { title: "Longitud máx.", value: "longMax", align: "center" },
        { title: "Formato", value: "formato", align: "center" },
        { title: "Requerido", value: "requerido", align: "center" },
        { title: "Descripción", value: "descripcion", align: "start" },
      ],
      closeIcon: enums.icons.CLOSE_ICON,
    };
  },
  async mounted() {
    await this.loadFormatoImportacion();
  },
  methods: {
    ...mapActions({
      setAlert: "user/setAlert",
      getFormatoImportacion: "farmacia/getFormatoImportacion",
    }),
    async loadFormatoImportacion() {
      this.loading = true;
      try {
        const payload = { tipoImportacionId: this.tipoImportacionId };
        const response = await this.getFormatoImportacion(payload);
        if (response) this.formatoData = response;
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al cargar el formato de importación: ${error}`,
        });
      } finally {
        this.loading = false;
      }
    },
    exportFormatEjemplo() {
      try {
        // Crear objeto con los datos de ejemplo usando datoEjemplo de cada campo
        const datoEjemplo = {};
        this.formatoData.forEach((campo) => {
          datoEjemplo[campo.nombreCampo] = campo.datoEjemplo || "";
        });

        const formatoExport = {
          filas: [datoEjemplo],
          hoja: this.nombreHojaExport,
        };
        
        helpersExcel.excelExport(formatoExport, this.nombreArchivoExport);
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al exportar el formato: ${error}`,
        });
      }
    },
    closeModal() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
.mobile-container {
  padding: 8px !important;
}
</style> 